<script lang="ts">
	import { Toaster } from '$lib/components/ui/sonner';
	import { getFlash } from 'sveltekit-flash-message';
	import { browser } from '$app/environment';
	import { ModeWatcher } from 'mode-watcher';
	import { toast } from 'svelte-sonner';
	import SvelteSeo from 'svelte-seo';
	import { page } from '$app/stores';
	import '../app.css';
	import { goto } from '$app/navigation';

	let { children } = $props();

	const flash = getFlash(page);

	$effect(() => {
		if ($flash && browser) {
			if ($flash.type === 'success') toast.success($flash.text);
			if ($flash.type === 'error') toast.error($flash.text);
		}
	});

	// goto admin page
	function handleKeydown(e: KeyboardEvent) {
		if (e.key === 'u' && (e.metaKey || e.ctrlKey) && $page.data.user?.roles?.includes('admin')) {
			e.preventDefault();
			goto('/');
		}

		if (e.key === 'i' && (e.metaKey || e.ctrlKey) && $page.data.user?.roles?.includes('admin')) {
			e.preventDefault();
			goto('/admin');
		}

		if (e.key === 'o' && (e.metaKey || e.ctrlKey) && $page.data.user?.roles?.includes('admin')) {
			e.preventDefault();
			goto('/referenten/uebersicht');
		}
	}
</script>

<svelte:document onkeydown={handleKeydown} />

<SvelteSeo title="ASGE - {$page.data.seo?.title}" description={$page.data.seo?.description} />

<ModeWatcher defaultMode={'light'} defaultTheme={'customer'} />

<Toaster position="bottom-right" />

{@render children?.()}
